import { useMemo } from 'react'
import TwinIcon, { TwinIconProp } from '../../../../baseComponents/TwinIcon'

interface CustomSelectTaskContactInfoRowProps {
    text?: string
    icon: TwinIconProp
}

const CustomSelectTaskContactInfoRow: React.FC<CustomSelectTaskContactInfoRowProps> = ({ text, icon }) => {
    if (!text) {
        return null
    }
    return (
        <div className='flex items-center'>
            <div className='mr-10 w-16'>
                <TwinIcon icon={icon} />
            </div>
            <span className='mr-10'>
                {text}
            </span>
        </div>
    )
}

interface CustomSelectTaskContactNotesProps {
    notes?: string
    icon: TwinIconProp
}

export const CustomSelectTaskContactNotes: React.FC<CustomSelectTaskContactNotesProps> = ({ notes, icon }) => {
    const textMemo = useMemo(() => {
        if (!notes) {
            return null
        }
        const separatedNotes = notes.split('\n')
        const textNotes: string[] = []
        for (const note of separatedNotes) {
            textNotes.push(note.replace(/<[^>]*>/g, ''))
        }
        return textNotes
    }, [notes])

    if (!textMemo) {
        return null
    }

    const renderThis: JSX.Element[] = []

    for (const key in textMemo) {
        const element = textMemo[key]
        renderThis.push(<div key={key} className='twin_elipsis max-h-50'>{element}</div>)
    }

    return (
        <div className='flex items-end'>
            <div className='mr-10 w-16 self-start'>
                <TwinIcon icon={icon} />
            </div>
            <p className='mr-10 max-w-300'>
                {renderThis}
            </p>
        </div>
    )
}

export default CustomSelectTaskContactInfoRow